import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Share from '../components/Share';
import {
  getAbsoluteIllustrationImage,
  getIllustrationById,
  getIllustrationCategoryLabel,
} from '../data/illustrations';
import './Illustrations.css';

function downloadPng(item) {
  if (!item?.imageSrc) {
    return;
  }

  const link = document.createElement('a');
  link.href = item.imageSrc;
  link.download = `${item.id}.png`;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function IllustrationDetail() {
  const { id } = useParams();
  const item = getIllustrationById(id);

  if (!item) {
    return (
      <div className="illustrations-page">
        <Header
          title="素材が見つかりません | ASMRキリスト教会"
          description="指定された素材は見つかりませんでした。"
          url={`https://www.asmrchurch.com/illust/${id}`}
        />
        <main className="illustrations-shell">
          <section className="illustrations-empty">
            <h1>素材が見つかりません</h1>
            <p>URLを確認するか、素材一覧から選び直してください。</p>
            <Link to="/illust">素材一覧へ</Link>
          </section>
        </main>
        <Footer />
      </div>
    );
  }

  const url = `https://www.asmrchurch.com/illust/${item.id}`;
  const image = getAbsoluteIllustrationImage(item);
  const description = `手書きフリー素材「${item.title}」。${item.tags.join('、')}の用途で使いやすいPNG素材です。`;
  const shareTitle = `【手書き素材】${item.title} - ASMRキリスト教会`;

  return (
    <div className="illustrations-page">
      <Header
        title={`${item.title} | 手書きフリー素材 | ASMRキリスト教会`}
        description={description}
        url={url}
        image={image}
      />

      <main className="illustrations-shell">
        <article className="illustration-detail">
          <div className="illustration-detail-image">
            <img src={item.imageSrc} alt={item.title} />
          </div>

          <div className="illustration-detail-panel">
            <p className="illustrations-kicker">Hand Drawn Free Material</p>
            <h1>{item.title}</h1>
            <p className="illustrations-handmade">掲載素材はすべて手書きのオリジナル素材です。</p>
            <p className="illustration-detail-description">{description}</p>

            <div className="illustration-detail-meta">
              <span>{getIllustrationCategoryLabel(item.category)}</span>
              {item.tags.map((tag) => (
                <span key={tag}>{tag}</span>
              ))}
            </div>

            <div className="illustration-detail-actions">
              <button type="button" onClick={() => downloadPng(item)}>
                PNGダウンロード
              </button>
              <Link to="/illust">素材一覧へ</Link>
            </div>

            <Share
              title={`${shareTitle} @asmrchurch #聖書 #キリスト教 #フリー素材`}
              url={url}
              text={description}
              image={image}
            />
          </div>
        </article>
      </main>

      <Footer />
    </div>
  );
}

export default IllustrationDetail;
